<template>
  <div class="pill" :style="pillElStyles">
    <span class="label">{{ label }}:</span>
    <span v-if="Array.isArray(value)">
      <span v-for="(item, index) in value" :key="index">
        {{ item }}
        <span v-if="index < value.length - 1" class="separator"></span>
      </span>
    </span>
    <span v-else>{{ value }}</span>
  </div>
</template>

<script>
export default {
  name: "JobDetailPill",
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Array, Number],
      required: true,
    },
    textColor: {
      type: String,
      default: "#000000",
    },
    backgroundColor: {
      type: String,
      default: "#f5f5f5",
    },
  },
  computed: {
    pillElStyles() {
      return {
        "--pill-text-color": this.textColor,
        "--pill-background-color": this.backgroundColor,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.pill {
  @include font-family("body");

  display: inline-flex;
  gap: 8px;
  align-items: self-start;

  padding: 5px 10px;

  font-size: 17px;
  font-weight: var(--cr-body-font-weight);
  line-height: 24px;
  color: var(--pill-text-color);

  background-color: var(--pill-background-color);
  border-radius: 10px;

  transition: all 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  .label {
    white-space: nowrap;
    opacity: 0.5;
  }
}

.separator {
  transform: translate(-2px, -4px);

  display: inline-block;

  width: 4px;
  height: 4px;
  margin: 0 4px;

  vertical-align: baseline;

  background-color: var(--pill-text-color);
  border-radius: 50%;
}
</style>
